import { render, staticRenderFns } from "./SskEmekliDetay.vue?vue&type=template&id=49d32cc5&scoped=true"
import script from "./SskEmekliDetay.vue?vue&type=script&lang=ts"
export * from "./SskEmekliDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d32cc5",
  null
  
)

export default component.exports